export default __webpack_public_path__ + "static/media/OGJ-Type-Design-Sequel-Sans-Bold-Obl-Head.ce535dee.woff";